<template>
    <div v-if="item.meta && item.meta.hidden"><!--Item 1: {{ item }}--></div>
    <div v-else-if="item.meta && item.meta.auth">
        <!--<p>Item 2: {{ item }}</p>-->
        <template v-if="item.children && item.children.length && hasAnyRole(item.meta.auth)">
            <q-collapsible
                :icon="item.meta && item.meta.icon ? item.meta.icon : 'keyboard_arrow_right'"
                :label="item.meta && item.meta.title ? item.meta.title : item.meta.resource"
                separator
                style="font-size:13px;"
                :opened="opened"
                :sublabel="item.meta.sublabel"
                class=""
            >
                <template v-for="child in item.children">
                    <!-- Nested -->
                    <sidebar-nav
                        v-if="child.children && child.children.length && child.meta && hasAnyRole(child.meta.auth)"
                        :key="child.path" :item="child"
                    ></sidebar-nav>
                    <template v-else-if="child.meta && child.meta.hidden"></template>
                    <q-item
                        v-else-if="child.meta && hasAnyRole(child.meta.auth)"
                        :key="child.path" separator link
                        :to="{ path: '/' + child.path }"
                        class=""
                        style="font-size:13px;"
                    >

                        <q-item-main>
                            <q-icon
                                :name="child.meta && child.meta.icon ? child.meta.icon : 'keyboard_arrow_right'"
                                size="16px"
                                class="q-mr-sm"
                                style="margin-right:20px;"
                                color=""
                            ></q-icon>
                            <span>{{ child.meta && child.meta.title ? child.meta.title : child.path }}</span>
                        </q-item-main>
                    </q-item>
                </template>
            </q-collapsible>
        </template>
        <template v-else> <!-- Don't have childern? -->
            <template v-if="item.meta && item.meta.hidden"></template>
            <div v-else-if="hasAnyRole(item.meta.auth)">
                <q-item
                    :key="item.path"
                    separator
                    link
                    :to="{ path: item.path }"
                    class="" style="font-size:13px;"
                >
                    <q-item-main>
                        <q-icon
                            :name="item.meta && item.meta.icon ? item.meta.icon : 'keyboard_arrow_right'"
                            size="16px"
                            class="q-mr-sm"
                            style="margin-right:20px;"
                            color=""
                        ></q-icon>
                        <span>{{ item.meta && item.meta.title ? item.meta.title : item.path }}</span>
                    </q-item-main>
                </q-item>
            </div>
        </template>
    </div>
    <!--<div v-else>Item 3: {{ item }}</div>-->
</template><!--<template>
  <q-collapsible
    :icon="item.meta && item.meta.icon ? item.meta.icon : 'keyboard_arrow_right'"
    :label="item.meta && item.meta.title ? item.meta.title : item.meta.resource"
    separator
    style="font-size:13px;"
    :opened="item.meta.opened"
    :sublabel="item.meta.sublabel"
    class=""
  >
    <template v-for="child in item.children">
      &lt;!&ndash; Nested &ndash;&gt;
      <sidebar-nav v-if="child.children && child.children.length" :key="child.path" :item="child"></sidebar-nav>
      <q-item
        :key="child.path"
        separator
        link
        :to="child.path"
        class=""
        v-else
      >
        <q-item-main>
          <q-icon :name="child.meta && child.meta.icon ? child.meta.icon : 'keyboard_arrow_right'" size="16px" class="q-mr-sm" style="margin-right:20px;" color=""
          ></q-icon>
          <span>{{ child.meta && child.meta.title ? child.meta.title : child.path }}</span>
        </q-item-main>
      </q-item>
    </template>
  </q-collapsible>
</template>-->
<script>
import {mapGetters} from 'vuex'

export default {
  name: 'SidebarNav',
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {
      opened: false
    }
  },
  computed: {
    ...mapGetters('auth', [
      'hasAnyRole'
    ]),
    shouldBeOpen () {
      return this.$breadcrumbs.some(crumb => crumb.regex.test(this.item.path))
    }
  },
  watch: {
    shouldBeOpen (v) {
      this.opened = !!v
    },
    $route: {
      handler (route) {
        this.opened = this.shouldBeOpen
      },
      immediate: true
    }
  }
}
</script>
